// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9dd95d0e","946":"1c0584e2"}[chunkId] + ".chunk.js";
};